module.exports = __webpack_public_path__ + "img/wear-detail.0fd3195c.png";